import React from 'react';
import NoticeStoreSave from '../NoticeStoreSave';

const NoticeStoreSaveWrap = (props) => {
  const {
    form,
    isEdit,
    pageName,
    noticeStoreInfo,
    onSubmit,
    insertImageCallback,
    onChangeAttachment,
    setData,
    noticeStoreLabelList,
  } = props;

  return (
    <div className="notice-store-save-wrap">
      {/* 상점 공지사항 등록/편집 */}
      <NoticeStoreSave
        form={form}
        isEdit={isEdit}
        pageName={pageName}
        noticeStoreInfo={noticeStoreInfo}
        noticeStoreLabelList={noticeStoreLabelList}
        onSubmit={onSubmit}
        insertImageCallback={insertImageCallback}
        onChangeAttachment={onChangeAttachment}
        setData={setData}
      />
    </div>
  );
};

export default NoticeStoreSaveWrap;
